@if (withAlert) {
  <div class="or-d-flex or-flex-col negative-margin-top-20-px or-mb-20-px">
    <div class="or-text-md or-text-align-center or-mb-20-px">
      Dbając o dobrą kulturę w naszej aplikacji, powinieneś wykonać następujące akcje:
    </div>

    <div class="border-shade border-radius-4 or-p-16-px or-bg-white or-mb-8-px">
      <div class="or-head-sm or-mb-4-px">Znajdź zastępstwo</div>
      <div class="or-text-sm">Poszukaj zawodnika na swoje miejsce i poinformuj gospodarza, że jest On za Ciebie.</div>
    </div>

    <div class="border-shade border-radius-4 or-p-16-px or-bg-white or-mb-20-px">
      <div class="or-head-sm or-mb-4-px">Napisz do organizatora gierki</div>
      <div class="or-text-sm">Kiedy nie możesz znaleźć zastępstwa, skontaktuj się z gospodarzem gierki.</div>
    </div>

    <div class="or-text-md or-text-align-center">
      W przypadku nie przyjścia na gierkę, gospodarz będzie mógł Ci wystawić czerwoną kartkę. Będzie ona widoczna w
      Twoim profilu dla wszystkich użytkowników.
    </div>
  </div>
}

<ion-radio-group (ionChange)="setData($event)" [value]="selected()">
  <div class="or-d-flex or-flex-col">
    @for (item of reasons; track item.value) {
      <ion-radio
        [value]="item.value"
        labelPlacement="end"
        alignment="center"
        justify="start"
        class="or-p-16-px or-mb-8-px or-w-100-pc"
        [ngClass]="isSelected(item.value) ? 'is-active or-bg-focus or-color-main-1' : 'is-no-active or-bg-white'">
        <div [ngClass]="isSelected(item.value) ? 'or-head-xs or-color-main-1' : 'or-text-sm or-color-black'">
          {{ item.name }}
        </div>
      </ion-radio>
    }
  </div>
</ion-radio-group>
